<template>
  <div>
    <v-layout wrap>
      <v-flex xs12>
        <v-card>
          <v-tabs grow v-model="model" centered slider-color="yellow">
            <v-tab v-for="i in values" :key="i">
              {{ i }}
            </v-tab>
          </v-tabs>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout wrap py-3>
      <v-flex xs12>
      <v-card v-if="model ==0" elevation="0">
 

<Dcharge/>
      </v-card>
        <v-card v-if="model ==1">
 

   <Doffer/>
      </v-card>
    </v-flex>
    </v-layout>
  </div>
</template>
<script>
import  Dcharge from './deliveryCharge';
import  Doffer from './deliveryoffer'
export default {

components:{
Dcharge,
Doffer
},

  data() {
    return {
      model: null,
      values: ["Delivery Charge", "Delivery Offer "],
    };
  },
};
</script>